/**
 * Resolve a `/`-separated path under the OPFS root to its directory handle.
 *
 * Rejects when any segment is missing — an index directory is expected to exist
 * already, since nothing here creates or downloads one.
 */
export async function opfsDirectory(path: string): Promise<FileSystemDirectoryHandle> {
    let dir = await navigator.storage.getDirectory();
    for (const segment of path.split("/").filter(Boolean)) {
        dir = await dir.getDirectoryHandle(segment);
    }
    return dir;
}
